// extracted by mini-css-extract-plugin
export default {"mCard":"eB-z","image":"fB-z","imageNoBackground":"gB-z","imageHasCategory":"hB-z","fullWidth":"iB-z"};